import React from 'react';
import ServicePage from '../components/ServicePage';
import img from '../assets/service2_1.jpeg';

const overview = [
  'Edge & Enterprise Connectivity Solutions covering WAN, Intranet, VPN, and enterprise-wide access networks.',
  'Data Centre & Storage Networking Solutions including high-performance data center networking and Storage Area Networks (SAN).',
  'Wireless Networking Solutions for indoor and outdoor environments.',
  'Collaboration & Unified Communication Solutions enabling secure and seamless enterprise collaboration.'
];

const features = [
  { title: 'Network Design',    text: 'Custom network architecture tailored to your business needs' },
  { title: 'Firewall & Security', text: 'Advanced firewall protection and intrusion detection systems' },
  { title: 'Access Control',    text: 'Secure access management and authentication systems' },
  { title: 'Network Monitoring', text: '24/7 monitoring and performance optimization' }
];

function NetworkService() {
  return (
    <ServicePage
      title="Network Solutions"
      subtitle="Secure and robust network infrastructure"
      img={img}
      imgAlt="Network Solutions"
      overview={overview}
      features={features}
      backAnchor="network"
    />
  );
}

export default NetworkService;
